import { render, staticRenderFns } from "./LeftArrowCustom.vue?vue&type=template&id=6bc1842e&scoped=true"
import script from "./LeftArrowCustom.vue?vue&type=script&lang=js"
export * from "./LeftArrowCustom.vue?vue&type=script&lang=js"
import style0 from "./LeftArrowCustom.vue?vue&type=style&index=0&id=6bc1842e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc1842e",
  null
  
)

export default component.exports